import { changeCurrency, selectCurrency } from 'legacy/lut/features/partner360/configuration'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { selectCockpitCurrency, setCockpitCurrency } from '../model'

listenerMiddleware.startListening({
  actionCreator: changeCurrency,
  effect: (action, { dispatch, getState }) => {
    if (selectCockpitCurrency(getState()) !== action.payload) {
      dispatch(setCockpitCurrency(action.payload))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: setCockpitCurrency,
  effect: (action, { dispatch, getState }) => {
    if (selectCurrency(getState()) !== action.payload) {
      dispatch(changeCurrency(action.payload))
    }
  },
})
